import React from 'react';
import { Form, Input, Button, Row } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import styles from './styles.less';

const FormItem = Form.Item;

class LoginForm extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.dispatch({
          type: 'login/login',
          payload: values,
        });
      }
    });
  };

  toForgotPassword(e) {
    e.preventDefault();
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: { routeName: 'FORGOT_PASSWORD' },
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className={styles.loginForm}>
        <FormItem>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: this.props.intl.formatMessage({ id: 'Components.LoginForm.Username.ErrorText' }) }],
          })(
            <Input
              maxLength={255}
              placeholder={this.props.intl.formatMessage({ id: 'Components.LoginForm.Username.Label' })}
            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: this.props.intl.formatMessage({ id: 'Components.LoginForm.Password.ErrorText' }) }],
          })(
            <Input
              maxLength={255}
              type="password"
              placeholder={this.props.intl.formatMessage({ id: 'Components.LoginForm.Password.Label' })}
            />,
          )}
        </FormItem>
        <Row className={styles.loginFormButton}>
          <Button type="primary" htmlType="submit">
            Log in
          </Button>
        </Row>
        <Row className={styles.loginFormForgot}>
          <a href="##" className={styles.btnNoBorder} onClick={this.toForgotPassword.bind(this)}>
            <FormattedMessage id="Components.LoginForm.ForgotPassword" />
          </a>
        </Row>
      </Form>
    );
  }
}

export default connect()(Form.create()(injectIntl(LoginForm)));



// WEBPACK FOOTER //
// ./src/components/LoginForm/LoginForm.js